import { facadeApi, facadeApiRaw, getDemoAwareFacadeApi } from 'helpers/api.helper';

export const getSimulationScenarios = (courseId: string) => facadeApi.get(`/content/simulation-ehr/content/getFull?courseId=${courseId}`);

export const getSimulaionScenarios = getSimulationScenarios;

export const getSimulationScenarioSummaries = (courseId: string) => facadeApi.get(`/content/simulation-ehr/content/summary?courseId=${courseId}`);

export const getSimulationCatalog = (courseId: string) => facadeApi.get(`/content/simulation-ehr/catalog/${courseId}`);

export const getSimulation = (simulationEhrId: string) => facadeApi.get(`/assignment/simulation-ehr/content/${simulationEhrId}`);

export const prepareDemoSimulationEhr = (payload) => facadeApiRaw.post('/assignment/simulation-ehr/prepare-demo', { data: payload });

export const getContentPhaseChartData = (phaseId: string) => facadeApi.get(`/content/case-study/content/chartData?phaseId=${encodeURIComponent(phaseId)}`);

export const getSequences = (assessmentId: number) => getDemoAwareFacadeApi(assessmentId).get(`/assignment/simulation-ehr/management/sequence?assessmentId=${assessmentId}`);

export const startPhase = (assessmentId: number) =>
  getDemoAwareFacadeApi(assessmentId).post(`/assignment/simulation-ehr/management/sequence-chunk/start?assessmentId=${assessmentId}`);

export const getCurrentOrFirstSequenceChunk = (assessmentId: number, phaseId?: string) =>
  getDemoAwareFacadeApi(assessmentId).get(`/assignment/simulation-ehr/management/sequence-chunk/current?assessmentId=${assessmentId}${phaseId ? `&phaseId=${phaseId}` : ''}`);

export const completePhase = (assessmentId: number) =>
  getDemoAwareFacadeApi(assessmentId).post(`/assignment/simulation-ehr/management/sequence-chunk/complete?assessmentId=${assessmentId}`);
